import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle, FormControlLabel, Typography
} from "@mui/material";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import React, { SyntheticEvent } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { ConfirmationDialogProps } from "../../../types/transition-types";

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
	open,
	title,
	message,
	onConfirm,
	onCancel,
	loading,
  doNotRemindMeCheckBoxKey
}) => {
  const currentUserId = useSelector((state: any) => state.user?.userData?.id);
  const { t } = useTranslation();
  const [doNotRemindMe, setDoNotRemindMe] = React.useState<boolean>(false);
	return (
		<Dialog
			open={open}
			onClose={onCancel}
			maxWidth='sm'
			fullWidth
			aria-labelledby='confirmation-dialog-title'
			aria-describedby='confirmation-dialog-description'
		>
			<DialogTitle
				id='confirmation-dialog-title'
				sx={{
					fontFamily: "Roboto",
					fontWeight: 500,
					fontSize: "20px",
					lineHeight: "24px",
					color: "#000000DE",
					padding: "24px 24px 8px 24px",
				}}
			>
				{title}
			</DialogTitle>
			<DialogContent
				sx={{
					padding: "8px 24px 20px 24px",
				}}
			>
				<DialogContentText
					id='confirmation-dialog-description'
					sx={{
						fontFamily: "Roboto",
						fontWeight: 400,
						fontSize: "14px",
						lineHeight: "20px",
						letterSpacing: "0.25px",
						color: "#00000099",
					}}
				>
					{message}
				</DialogContentText>
			</DialogContent>
			<DialogActions
				sx={{
					padding: "20px 45px",
					gap: "8px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
				}}
			>
        <FormControlLabel
          control={<Checkbox
            checked={doNotRemindMe}
          />}
          label={
            <Typography
              component="span"
              sx={{
                fontFamily: "Roboto",
                fontSize: "14px",
                color: "rgba(0,0,0,0.87)"
              }}
            >
              {t("full-time-worker-scheduler_do-not-remind-me")}
            </Typography>
          }
          onChange={(event:SyntheticEvent<Element, Event>, checked) => {
            setDoNotRemindMe(checked);
          }}
        />
        <Box sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          flexDirection: "row",
          justifyContent: "flex-end"
        }}>
          <Button
            onClick={onCancel}
            variant='text'
            sx={{
              fontFamily: "Roboto",
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "20px",
              letterSpacing: "0.1px",
              textTransform: "uppercase",
              minWidth: "64px",
              padding: "8px 16px",
            }}
          >
            {t("common_cancel")}
          </Button>
          <Button
            onClick={() => {
              if (doNotRemindMe && doNotRemindMeCheckBoxKey) {
                localStorage.setItem(`${doNotRemindMeCheckBoxKey}-${currentUserId}`, "true");
              }
              onConfirm();
            }}
            variant='contained'
            sx={{
              fontFamily: "Roboto",
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "20px",
              letterSpacing: "0.1px",
              textTransform: "uppercase",
              minWidth: "64px",
              padding: "8px 16px",
            }}
            loading={loading}
          >
            {t("full-time-worker-scheduler_confirm")}
          </Button>
        </Box>
			</DialogActions>
		</Dialog>
	);
};

export default ConfirmationDialog;
